import { render, staticRenderFns } from "./DnsListBatchWise.vue?vue&type=template&id=27fd2325"
import script from "./DnsListBatchWise.vue?vue&type=script&lang=js"
export * from "./DnsListBatchWise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports